/**
 * Botão "Instalar no celular": só aparece quando o navegador realmente
 * oferece instalação (evento beforeinstallprompt). Não usa sessionStorage;
 * visibilidade controlada só por CSS + classe .is-installable.
 */
let deferredPrompt;

function hidePwaInstall() {
  const el = document.getElementById('pwa-install-container');
  if (el) el.classList.remove('is-installable');
}

function showPwaInstall() {
  const el = document.getElementById('pwa-install-container');
  if (el) el.classList.add('is-installable');
}

function initPwaInstall() {
  const installContainer = document.getElementById('pwa-install-container');
  const installBtn = document.getElementById('btnInstallPWA');

  if (!installContainer || !installBtn) return;

  hidePwaInstall();

  installBtn.onclick = async () => {
    if (!deferredPrompt) return;
    hidePwaInstall();
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    deferredPrompt = null;
  };
}

// Só mostrar quando o navegador disparar beforeinstallprompt (PWA instalável)
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  // Já instalado (standalone)? Não mostrar
  if (window.matchMedia('(display-mode: standalone)').matches) return;
  showPwaInstall();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPwaInstall);
} else {
  initPwaInstall();
}
document.addEventListener('turbolinks:load', initPwaInstall);
